import { jsx as _jsx } from "react/jsx-runtime";
import { SelectCombobox } from '@bos/ui';
import { useController } from 'react-hook-form';
export const SelectComboboxField = ({ control, name, registerOptions, onOpenChange, ...selectInputProps }) => {
    const { field, fieldState } = useController({
        control,
        name,
        ...registerOptions,
    });
    const handleOpenChange = (open) => {
        onOpenChange?.(open);
        if (!open) {
            field.onBlur();
        }
    };
    const handleValueChange = (value) => {
        field.onChange(value);
        /*
        There is no native way to handle an onBlur event.
        We need to revalidate the form when user changes the value.
        */
        field.onBlur();
    };
    const currentValue = field.value ?? '';
    return (_jsx(SelectCombobox, { ...selectInputProps, value: currentValue, error: fieldState.error?.message, onOpenChange: handleOpenChange, onValueChange: handleValueChange }));
};
